<main id="db-wrapper">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
     <section id="page-content">
         <div class="header">
          <app-only-admin-navigation></app-only-admin-navigation>
         </div>

          <div class="container-fluid p-4" *ngIf="loading">
            <app-header-spinner>

            </app-header-spinner>
            <app-form-spinner></app-form-spinner>
          </div>
         <div class="container-fluid p-4" *ngIf="!loading">
           <div class="row">
             <div class="col-xl-12 mb-3 col-md-12 col-12">
               <div class="bg-primary py-6  px-xl-0 rounded-4 ">
                 <div class="row align-items-center">
                   <div class="offset-xl-1 col-xl-5 col-md-6 col-12">
                     <div>
                       <h2 class="h1 text-white mb-3 px-5">Lets manage Our blog posts</h2>
                       <p class="text-white fs-4 px-5">
                        Manage Blog Posts
                       </p>
                       
                     </div>
                   </div>
                   
                 </div>
               </div>
             </div>
            </div>

           <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-6 col-6 d-flex" *ngFor="let post of sessionDataArray" >
              <!-- Card -->
              <div class="card mb-4 shadow-lg">
                <a  class="card-img-top"   [routerLink]="['/showPostsdetail', post.id]">
                    <!-- Img  -->
                  <img src="{{post.image}}" class="card-img-top rounded-top-md" style="height: 300px;" alt="blogpost"></a>
                <!-- Card body -->
                <div class="card-body">

                  <h6>
                    <a  class="text-inherit"  [routerLink]="['/showPostsdetail', post.id]" >
                     {{post.title}}
                    </a>
                  </h6>
                </div>
                <div class="card-footer d-flex justify-content-between">
                  <a (click)="selectRecord(post)" class="btn btn-primary"  (click)="visible = true">Edit</a>
                  <a (click)="deRecord(post.id)" class="btn btn-danger" >Delete</a>

                </div>
              </div>
            </div>
           </div>
       </div>

     </section>
   </main>


   <div class="card flex justify-center">
    <p-dialog header="Edit Post" [modal]="true" [(visible)]="visible" [style]="{ width: '35rem' }">
      <form [formGroup]="recordForm">
        <input type="hidden" formControlName="id">
        <div class="form-group my-2">
          <div class="text-center">
            <span class="avatar avatar-xxl  " *ngIf="imageUrl!==''">
                <img src={{imageUrl}} alt="" class="rounded-circle">
              </span>
          </div>
          </div>
        <div class="form-group my-2">
          <label for="Image">Image /Icon for Card:</label><br>
          <input type="file" (change)="upload($event)" class="form-control" required accept="image/png, image/jpeg, image/webp, image/svg+xml">
          </div>
        <div class="mb-3">
          <label for="title" class="form-label">Title</label>
          <input type="text" class="form-control" id="title" formControlName="title">
        </div>
        <div class="form-group my-2">
          <label for="metaDescription">Meta Description</label>
          <textarea id="metaDescription" formControlName="metaDescription" class="form-control"></textarea>
          <div *ngIf="recordForm.get('metaDescription')?.hasError('required') && recordForm.get('metaDescription')?.touched" class="error-message text-danger">
            Meta Description is required.
          </div>
        </div>
        <div class="mb-3">
          <label for="description" class="form-label">Description</label>
          <p-editor formControlName="description" [style]="{ height: '320px' }" />
          <div *ngIf="recordForm.get('description')?.hasError('required') && recordForm.get('description')?.touched" class="error-message text-danger">
            Description is required.
          </div>
        </div>
        <div class="row mb-2 px-2">
          <button type="button" class="btn btn-primary" (click)="updateRecord()">Save changes</button>
        </div>
      </form>
        
    </p-dialog>
</div>






